import { AddressesApiRemoteService } from '../../Services/api/addresses/addresses-service'
import { IAddressSearchResponse } from '../../Services/api/addresses/addresses.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class SearchAddressesUseCase
implements IFormUsecase<string, IAddressSearchResponse> {
  constructor (private readonly AddressesApi: AddressesApiRemoteService) {}
    

  public async handle (
    zipcode: string
  ): Promise<Result<IAddressSearchResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.AddressesApi.search(zipcode)

      if (response.isFailure) {
        return response
      }
    
      const Search = response.getValue()

      if(!Search) return response
    
      return Result.ok(Search)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
